import { Box, Typography } from "@mui/material";
import { useTheme } from "../../components/context/context";
import BasicTable from "../../components/basicTable/BasicTable";

export default function AboutUs() {
    const { fontSize } = useTheme();
    return (
        <Box sx={{ fontSize: `${fontSize}rem` }}>
            <Typography variant="h1" sx={{ fontSize: `${fontSize + 0.5}rem`, margin: "5px 0" }}>About Us</Typography>
            <hr />
            <Box sx={{ padding: "2px 0 2px 10px", marginTop: "20px", textAlign:"justify" }}>
                <div style={{ marginBottom: "1rem" }}>
                    <b>MSSAT ACT -</b>
                    <ul>
                        <li>First State in the country to pass an exclusive legislation on Social Audit</li>
                        <li>Enacted by the Legislature of the State of Meghalaya om the Six eight Year of the Republic of India
                        </li>
                        <li>Meghalaya Community Participation and Public Services Social Audit Act, 2017</li>
                    </ul>
                </div>
                <b >Architecture Levels -</b>
                <ul>
                    <li>State Level - Prepare Social Audit Reporting Formats, Resource Material, guidelines, entitlements for various schemes, process maps to facilitate social audit.
                    </li>
                    <li>District Level - To finalize and approve block wise social audit calendar Select and empanel NGOs and SHGs to do the audit. Review, coordinate, supervise and monitor social audits taken up in the Block as well as coordinate with Social Audit Nodal Officers and ensure effective participation. Conduct Public Hearings and ensure time bound redress. Finally, to prepare and submit Social Audit Reports to the State Council.
                    </li>
                </ul>
                <b >Village Level - </b>
                <ul>
                    <li>General Body of the Village Employment Council shall identify a ‘Village level Social Audit Committee’ (VSAC) which will assist the Social Audit Facilitators in carrying out social audits.
                    </li>
                    <li>An agreement will be signed between the VSAC and the District Social Audit Coordinator for conduct of social audit in respective villages
                    </li>
                    <li>Representatives of NGOs and SHGs to come as Social Audit Facilitators (SAF) to assist VSAC </li>
                </ul>

                <b>Objectives -</b>
                <ul>
                    <li>Facilitate concurrent audit of schemes and programmes</li>
                    <li>Monitor effectiveness and efficiency in implementation
                    </li>
                    <li>Increase transparency in programmes and institutions</li>
                    <li>Educate citizens, make them aware of rights</li>
                    <li>Enhance citizen ownership in development initiatives
                    </li>
                    <li>Fact finding at field level </li>
                    <li>Seek feedback from people on implementation
                    </li>
                    <li>Provide a platform for registering grievances and redressal within stipulated time frame
                    </li>
                </ul>
                <b>Scope of the ACT -</b>
                <ul>
                    <li>Education (Sarva Shiksha Abhiyan, Midday Meal) </li>
                    <li>Health (immunization, services of Sub Center, Primary Health Center, Community Health Center)
                    </li>
                    <li>Forest & Environment (Joint Forest Management Committee) </li>

                    <li>Power (Village Power Committees, services of MoECL)</li>
                    <li>Water & Sanitation (Quality and quantity of water supply, services of PHE Dept, Swacch Bharat Mission)
                    </li>
                    <li>Employment & Skilling
                    </li>
                    <li>Roads & Transport (Public Works Department, PMGSY)
                    </li>
                    <li>Agriculture & Allied activities
                    </li>
                    <li>Community and Rural Development (MGNREGA, PMAY -G NSAP)
                    </li>
                    <li>Security (local police, village defence parties)
                    </li>
                    <li>Food & Civil Supplies (PDS)
                    </li>
                    <li>Social Welfare (ICDS)
                    </li>
                </ul>
                <b>MSSAT Structure -</b>
                <ul>
                    <li>The Office of MSSAT is headed by the Director and subordination of the Joint.Director along with the PM Administration, HR, Social Audit Experts and the Junior Consultants at the State Level.
                    </li>
                    <li>The Office Head also has the PM Accounts, Accounts cum Office Assistance and the Multi Task Assistance Staff.

                    </li>
                    <li>At the District Level, MSSAT has deployed District Resource Persons in each District of the State to oversee all Block related works in their respective Districts.</li>
                    <li>Block Resource Persons and Village Resource Persons are deployed in each Block depending on the numbers of VECs to conduct Social Audit Process and Report back to the District and State Office.
                    </li>
                </ul>
                <b>Establishment of Social Audit Unit</b>
                <br />
                <br />
                An independent Society, hereafter referred to, as "Meghalaya Society for Social Audit & Transparency (MSSAT)", shall be established by
                the State Government to facilitate conduct of Social Audits by Village Employment Councils (VECs) and such other bodies as may be decided
                from time to time. The Society shall be an organization providing for periodical conduct of Social Audit of Mahatma Gandhi National Rural
                Employment Guarantee Scheme to ensure enhancement of livelihoods of the households in rural areas of the State of Meghalaya. The main
                objective shall be continuous public vigilance to ensure accountability in the implementation of projects and policies. The works taken
                up under the Scheme shall be referred to the public hearings convened by the Village Employment Council (VECs) in accordance with the Act
                and the guidelines.
                <br />
                <br />
                <b>
                    Governing Body
                </b>
                <br />
                <br />
                <div>
                    The management of the affairs of the Society shall vest in the Governing Body in accordance with the Bye-laws of the Society
                    of which the members are:-
                </div>
                <br />
                <div style={{ display: "flex", justifyContent: "center" }}>

                    <BasicTable heading={heading} data={data} />
                </div>
            </Box>
        </Box>
    )
}

const heading = [
    {
        data: "#",
        width: "5%",
    },
    {
        data: "Name & Occupation",
        width: "80%",
    },
    {
        data: "Designation",
        width: "15%",
    }

]
const data = [
    ["1.", "Chief Secretary, Government of Meghalaya.", "Chairman"],
    ["2.", "Principal Accountant General (C&AG), Meghalaya", "Member"],
    ["3.", "Principal Secretary to the Government of Meghalaya, Community & Rural Development Department", "Member"],
    ["4.", "Principal Secretary to the Government of Meghalaya, Finance Department", "Member"],
    ["5.", "Principal Secretary to the Government of Meghalaya,  Planning Department", "Member"],
    ["6.", "Director, Community & Rural Development (C&RD) Department, Meghalaya", "Member"],
    ["7.", "Mission Director, State Rural Employment Society (SRES), Meghalaya", "Member"],
    ["8.", "Director, State Institute of Rural Development (SIRD), Nongsder ", "Member"],
    ["9.", "All Deputy Commissioners & District Programme Coordinators of the Districts in Meghalaya", "Member"],
    ["10.", "Principal, Extension Training Centres (ETC), Nongsder and Tura, Meghalaya", "Member"],
    ["11.", "Administrator, Bosco Integrated Development Society (BIDS), Shillong", "Member"],
    ["12.", "Director, BAKDIL, Tura", "Member"],
    ["13.", "Shri. P.Kharkongngor, IAS (Retd)", "Member"],
    ["14.", "Director, Meghalaya Society For Social Audit & Transparency", "Member"],
]